module.exports = __webpack_public_path__ + "static/banner-one-shape5-2e88f679c8f944cf96f192081800c890.png";